import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";

// Import menuDropdown
import RightSide from "../CommonForBoth/TopbarDropdown/RightSide";
import Navbar from "./Navbar";
import dummyLogo from "../../assets/basicTheme/images/dummyLogo.png";
//i18n
import { withTranslation } from "react-i18next";
import { verifyData } from "../../pages/Common/CommonFunctions/commonFunctions";

const Header = (props) => {
  const data = JSON.parse(localStorage.getItem("authUser"));
  const isMenuOpened = "false";

  document.querySelectorAll(".navbar-header").forEach((button) => {
    button.addEventListener("click", (event) => {
      if (
        event.target.className.includes("nav-link dropdown-toggle arrow-none")
      ) {
        //pass
      } else if (event.target.className.includes("fa fa-fw fa-bars")) {
        //pass
      } else {
        if (props?.leftMenu !== undefined && props.leftMenu) {
          props.toggleLeftmenu(!props.leftMenu);
        }
      }
    });
  });
  function handleLeftMenu() {
    if (props?.leftMenu !== undefined && props.leftMenu) {
      props.toggleLeftmenu(!props.leftMenu);
    }
  }

  return (
    <React.Fragment>
      <div className="navbar-header navbar-header-top">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to="/" className="logo logo-dark" id="as-logo">
              <span className="logo-lg" id="as-logo-lg">
                <img
                  src={verifyData(data?.logo) ? data?.logo : dummyLogo}
                  alt=""
                  height={verifyData(data?.logo) ? "50" : "25"}
                />
              </span>
            </Link>
          </div>

          <button
            type="button"
            className="btn btn-sm px-2 font-size-16 d-xl-none header-item"
            id="as-menu"
            data-toggle="collapse"
            onClick={() => {
              props.toggleLeftmenu(!props.leftMenu);
            }}
            data-target="#topnav-menu-content"
          >
            <i className="fa fa-fw fa-bars" />
          </button>

          <Navbar menuOpen={isMenuOpened} toggleLeftMenu={handleLeftMenu} />
        </div>
        <div className="d-flex">
          <RightSide />
        </div>
      </div>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
